import { RedoOptionCard } from "@redotech/redo-web/arbiter-components/option-card/redo-option-card";
import { memo } from "react";
import type { IntakeQuestion } from "../../registry/types";

type IntakeOptionLayout = NonNullable<IntakeQuestion["layout"]>;
type IntakeOptionData = IntakeQuestion["options"][number];

export interface IntakeOptionProps {
  option: IntakeOptionData;
  layout: IntakeOptionLayout;
  isSelected: boolean;
  animateReveal?: boolean;
  className?: string;
  disabled?: boolean;
  onBlur?: () => void;
  onClick: () => void;
  onFocus?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  revealIndex?: number;
}

export const IntakeOption = memo(function IntakeOption({
  option,
  layout,
  isSelected,
  animateReveal,
  className,
  disabled,
  onBlur,
  onClick,
  onFocus,
  onMouseEnter,
  onMouseLeave,
  revealIndex,
}: IntakeOptionProps) {
  return (
    <RedoOptionCard
      animateReveal={animateReveal}
      badges={option.badges}
      className={className}
      disabled={disabled}
      Icon={option.Icon}
      label={option.label}
      layout={layout}
      onBlur={onBlur}
      onClick={onClick}
      onFocus={onFocus}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      revealIndex={revealIndex}
      selected={isSelected}
    />
  );
});
